import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import Container from '../../components/Container';

import { RouterState } from '../../components/Grid';
import Related from '../../components/Related';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { getCreatorInfo } from '../../store/actions';
import {Helmet} from 'react-helmet';

import * as S from './style';
import { RAZZLE_APP_PORTAL_LINK } from '../../constants';

let i = 0;

const Author: React.FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { creators } = useAppSelector(state => state.creator);
    const { author } = useParams<RouterState>();
    const user = creators.find(user => user.username === author);
    
    useEffect(() => {
        while (i <= creators.length) {
            if (user && user.username === author) {
                return 
            } else {
                dispatch(getCreatorInfo(author));
            }

            i++;
        }
    }, [dispatch, author, creators.length, user && user.username])

    return (
        <>
            <Helmet>
                <title>{`Unitiva: ${user && user.fullname}`}</title>
                <meta name="description" content={user && user.biography} />
                <meta property="og:title" content={`Unitiva: ${user && user.fullname}`} />
                <meta property="og:description" content={user && user.biography} />
                <meta property="og:image" content={user && user.portrait} />
                <meta property="og:image:type" content="image/png" />
                <meta property="og:url" content={typeof window !== "undefined" ? window.location.href : `${RAZZLE_APP_PORTAL_LINK}${location.pathname}` } />
                <link rel="canonical" href={typeof window !== "undefined" ? window.location.href : `${RAZZLE_APP_PORTAL_LINK}${location.pathname}` } />
            </Helmet>
            <Container>
                <S.Creator>
                    <S.ImageWrapper>
                        <img src={user && user.portrait} alt={user && user.username} />
                    </S.ImageWrapper>
                    <S.CreatorInfo>
                        <h1>{user && user.fullname}</h1>
                        <br />
                        <p>{user && user.biography}</p>
                    </S.CreatorInfo>
                </S.Creator>
                {user && user.items && <Related title={`Articoli di ${user && user.fullname}`} items={user.items} />}
            </Container>
        </>
    )   
}

export default Author;